@if(hasStagingAccess) {
  @if(showSelect) {
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-select
        [placeholder]="'Select version'"
        [value]="currentValue"
        (selectionChange)="onStageChange($event.value)"
        panelClass="custom-option"
      >
        <mat-option
          *ngFor="let stage of stages"
          [value]="stage.value"
        >
          {{ stage.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  }
}
